import { render, staticRenderFns } from "./myCompany.vue?vue&type=template&id=fce8d65c&"
import script from "./myCompany.vue?vue&type=script&lang=js&"
export * from "./myCompany.vue?vue&type=script&lang=js&"
import style0 from "./myCompany.vue?vue&type=style&index=0&id=fce8d65c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports